<div class="hss-row dp-summary">
  <span [class.e-label]="enhanced">D/P {{ dpState }} </span>
  <span
    [class.e-value]="enhanced"
    [class]="hssBuilderService.getChangedClass(dp.greaterTime.didChange, index)"
    >{{ dp.greaterTime.text.padStart(5, " ") }}</span
  >
  <span [class.e-label]="enhanced">{{ "P/C".padStart(11, " ") }} </span>
  <span
    [class.e-value]="enhanced"
    [class]="
      hssBuilderService.getChangedClass(dp.payCreditDisplayed.didChange, index)
    "
    >{{ dp.payCreditDisplayed.text.padStart(6, " ") }}</span
  >
  <span [class.e-label]="enhanced">{{ "TL".padStart(3, " ") }} </span>
  <span
    [class.e-value]="enhanced"
    [class]="
      hssBuilderService.getChangedClass(
        dp.payCreditDisplayed.didChange || dp.greaterTime.didChange,
        index
      )
    "
    >{{ hssBuilderService.getDpTotal(dp).padStart(5, " ") }}</span
  >
  @if (isSplitDuty()) {
    <span [class.e-value]="enhanced"
      >{{ "5.15C/".padStart(18, " ") }}{{ getSplitDutyStartDate() }}</span
    >
  }
</div>
<div
  class="hss-row dp-summary"
  [class.opacity-5]="enhanced && dpState !== 'SKD'"
>
  @if (hssBuilderService.getSchedOnDuty(dp); as schedOnDuty) {
    <span [class.e-label]="enhanced">SKD ONDUTY </span>
    <span
      [class.e-value]="enhanced"
      [class]="hssBuilderService.getChangedClass(schedOnDuty.didChange, index)"
      >{{ schedOnDuty.text.padStart(5, " ") }}
    </span>
  }
  @if (!hssBuilderService.isLastDp(hss, dp.index)) {
    @if (
      hssBuilderService.getSchedOdl(hss, dp.index, dp.index + 1);
      as schedOdl
    ) {
      @if (schedOdl.text !== "") {
        <span [class.e-label]="enhanced">ODL </span>
        <span
          [class.e-value]="enhanced"
          [class]="hssBuilderService.getChangedClass(schedOdl.didChange, index)"
          >{{ (schedOdl.text | hssDuration).padStart(6, " ") }}
        </span>
      }
    }
  }
</div>
@if (dpState !== "SKD") {
  <div class="hss-row dp-summary">
    @if (hssBuilderService.getActualOnDuty(dp); as actualOnDuty) {
      @if (dpState === "GTR") {
        <span [class.e-label]="enhanced">ACT ONDUTY </span>
      } @else {
        <span [class.e-label]="enhanced">{{ dpState }} ONDUTY </span>
      }
      <span
        [class.e-value]="enhanced"
        [class]="
          hssBuilderService.getChangedClass(actualOnDuty.didChange, index)
        "
        >{{ actualOnDuty.text.padStart(5, " ") }}
      </span>
    }
    @if (!hssBuilderService.isLastDp(hss, dp.index)) {
      @if (
        hssBuilderService.getActualOdl(hss, dp.index, dp.index + 1);
        as actOdl
      ) {
        @if (actOdl.text !== "") {
          <span [class.e-label]="enhanced">ODL </span>
          <span
            [class.e-value]="enhanced"
            [class]="hssBuilderService.getChangedClass(actOdl.didChange, index)"
            >{{ (actOdl.text | hssDuration).padStart(6, " ") }}
          </span>
        } @else {
          <span>{{ " ".padEnd(11, " ") }}</span>
        }
      }
    } @else {
      <span>{{ " ".padEnd(11, " ") }}</span>
    }
    @if (
      hssBuilderService.getSignInTimeText(hss, dp, stationTimeZones);
      as signInText
    ) {
      <span
        [class.e-value]="enhanced"
        [class]="
          hssBuilderService.getChangedClass(dp.fdpStartAcclim.didChange, index)
        "
        >{{ signInText }}</span
      >
    }
  </div>
}
@if (dp.fdpDuration.text !== "0") {
  <div class="hss-row dp-summary">
    <span [class.e-label]="enhanced">FDPT</span>
    <span
      [class.e-value]="enhanced"
      [class]="
        hssBuilderService.getChangedClass(dp.fdpDuration.didChange, index)
      "
      >{{
        hssBuilderService.timeFromMinutes(dp.fdpDuration.text).padStart(6, " ")
      }}</span
    >
    <span [class.e-label]="enhanced">{{ "START".padStart(14, " ") }} </span>
    <span
      [class.e-value]="enhanced"
      [class]="
        hssBuilderService.getChangedClass(dp.fdpStartAcclim.didChange, index)
      "
    >
      {{ dp.fdpStartAcclim.text | hssTime }} &nbsp;</span
    >
    <span [class.e-label]="enhanced">END </span>
    <span
      [class.e-value]="enhanced"
      [class]="
        hssBuilderService.getChangedClass(dp.fdpEndAcclim.didChange, index)
      "
    >
      {{ dp.fdpEndAcclim.text | hssTime }} &nbsp;</span
    >
    <span [class.e-label]="enhanced">ACC STA </span>
    <span
      [class.e-value]="enhanced"
      [class]="
        hssBuilderService.getChangedClass(dp.acclimStation.didChange, index)
      "
      >{{ dp.acclimStation.text }}</span
    >
  </div>
}
@if (
  hssBuilderService.getRapText(hss.header.empNum.text, dp, raps);
  as rapText
) {
  <div
    class="hss-row dp-summary"
    [class]="
      hssBuilderService.getChangedClass(hss.header.empNum.didChange, index)
    "
  >
    <span>{{ " ".padEnd(28, " ") }}</span>
    <span [class.e-label]="enhanced">{{ rapText }}</span>
  </div>
}
